import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticationGuard } from './core/guards/auth.guard';
import { GuidedOrderResolver } from './shared/services/guided-order-resolver.service';
import { LogoutComponent } from './shared/logout/logout.component';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./features/my-orders/my-orders.module')
      .then(m => m.MyOrdersModule),
    canActivate: [AuthenticationGuard],
    resolve: {
    },
    data: { module: 'guided-ordering' }
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: 'guidedOrder/:param',
    loadChildren: () => import('./features/guided-order/guided-order.module').then(m => m.GuidedOrderModule),
    resolve: {
      news: GuidedOrderResolver
    },
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'guidedOrder',
    loadChildren: () => import('./features/guided-order/guided-order.module').then(m => m.GuidedOrderModule),
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'samples',
    loadChildren: () => import('./features/guided-order/samples/samples.module')
      .then(m => m.SamplesModule),
    canActivate: [AuthenticationGuard],
    outlet: 'guidedOrderRoute'
  },
  {
    path: 'ordernship',
    loadChildren: () => import('./features/guided-order/order-n-ship/order-n-ship.module')
      .then(m => m.OrderNShipModule),
    canActivate: [AuthenticationGuard],
    outlet: 'guidedOrderRoute'
  },
  {
    path: 'reviewnconfirm',
    loadChildren: () => import('./features/guided-order/review-n-confirm/review-n-confirm.module')
      .then(m => m.ReviewNConfirmModule),
    canActivate: [AuthenticationGuard],
    outlet: 'guidedOrderRoute'
  },
  {
    path: 'summary',
    loadChildren: () => import('./features/order-summary/order-summary.module')
      .then(m => m.OrderSummaryModule),
    canActivate: [AuthenticationGuard],
    resolve: {
    },
    data: { module: 'guided-ordering' }
  },
  {
    path: 'downloadFile',
    loadChildren: () => import('./features/download-file/download-file.module')
      .then(m => m.DownloadFileModule),
    canActivate: [AuthenticationGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
